const routes = [
  {
    path: "/home",
    redirect: "/"
  },
  {
    path: "/inicio",
    redirect: "/"
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/TheHome.vue"),
    meta: {
      title: "minhamola | inicio"
    }
  },
  {
    path: "/entrar",
    name: "signin",
    component: () => import("../views/TheSignIn.vue"),
    meta: {
      title: "entrar | minhamola"
    }
  },
  {
    path: "/registar-se",
    name: "signup",
    component: () => import("../views/TheSignUp.vue"),
    meta: {
      title: "registar-se | minhamola"
    }
  },
  {
    path: "/perfil",
    name: "profile",
    component: () => import("../views/TheUserProfile.vue"),
    meta: {
      title: "perfil | minhamola"
    }
  },
  {
    path: "/contas",
    name: "accounts",
    component: () => import("../views/TheAccounts.vue"),
    meta: {
      title: "contas | minhamola"
    }
  },
  {
    path: "/contas/criar-conta",
    name: "accountCreate",
    component: () => import("../views/TheAddAccount.vue"),
    meta: {
      title: "criar nova conta | minhamola"
    }
  },
  {
    path: "/verificar-codigo",
    name: "OTPConfirmation",
    component: () => import("../views/OTPConfirmation.vue"),
    meta: {
      title: "verificar codigo | minhamola"
    }
  },
  {
    path: "/contas/:accountID/definicoes",
    name: "accountSettings",
    component: () => import("../views/TheAccountSettings.vue"),
    meta: {
      title: "definicoes da conta | minhamola"
    },
    props: { accountData: {} }
  },
  {
    path: "/contas/:accountID/transaccoes",
    name: "accountTransactions",
    component: () => import("../views/TheAccountTransactions.vue"),
    meta: {
      title: "transaccoes da conta | minhamola"
    },
    props: { accountData: {} }
  },
  {
    path: "/contas/:accountID/relatorios",
    name: "accountReport",
    component: () => import("../views/TheAccountReports.vue"),
    meta: {
      title: "relatorios da conta | minhamola"
    }
  },
  {
    path: "/contas/:accountID/adicionar-operacao",
    name: "accountOperationRegister",
    component: () => import("../views/TheAccountOperationRegister.vue"),
    meta: {
      title: "registar operacao da conta | minhamola"
    }
  },
  {
    path: "/contas/:accountID/editar-operacao",
    name: "accountOperationEdit",
    component: () => import("../views/TheAccountOperationEdit.vue"),
    meta: {
      title: "editar operacao da conta | minhamola"
    }
  },
  {
    path: "/dicas-de-gestao",
    name: "moneyManagementTips",
    component: () => import("../views/TheMoneyManagementTips.vue"),
    meta: {
      title: "dicas de gestao | minhamola"
    }
  },
  {
    path: "/sobre-a-aplicacao",
    name: "aboutTheApplication",
    component: () => import("../views/TheAbout.vue"),
    meta: {
      title: "sobre a aplicacao | minhamola"
    }
  },
  {
    path: "/perguntas-frequentes",
    name: "frequentlyAskedQuestions",
    component: () => import("../views/TheFAQs.vue"),
    meta: {
      title: "perguntas frequentes | minhamola"
    }
  },
  {
    path: "/contacte-me",
    name: "contact",
    component: () => import("../views/TheContact.vue"),
    meta: {
      title: "contacte-me | minhamola"
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "pageNotFound",
    component: () => import("../views/PageNotFound.vue"),
    meta: {
      title: "404 | minhamola"
    }
  }
];

export default routes;